import React from 'react';
import type { ICellRendererParams } from 'ag-grid-community';
import type { ReviewCellRendererProps } from '../helpers';
import { Icon, type OptionType, TriggerableMenu } from 'venn-ui-kit';
import { convertToTriggerableMenuOption, performMappingUpdate } from './rendererHelpers';

const CURRENCY_DROPDOWN_EXPECTED_HEIGHT = 500;

export const CurrencyCellRenderer = (props: ICellRendererParams & ReviewCellRendererProps) => {
  const { data, metadata, additionalMetadata } = props;
  const currencyOptions = metadata.currency.map(convertToTriggerableMenuOption);
  const { isNew, isReturns } = additionalMetadata.perSeries[data.seriesId]!;

  const currentSelection = currencyOptions.find((c) => c.value === data.currency)?.value ?? '--';

  return (
    <div className="py-[8px] text-[12px] text-venn-black leading-[16px]">
      {isNew ? (
        <TriggerableMenu
          portalProps={{
            // Ensure the dropdown doesn’t fall off the bottom of the view
            expectedHeight: CURRENCY_DROPDOWN_EXPECTED_HEIGHT,
          }}
          usePortal
          options={currencyOptions}
          innerClassName="mt-[19px] max-h-fit"
          className="min-h-[16px] font-bold text-venn-dark-blue cursor-pointer"
          onSelect={(selectedOption: OptionType<string | number>) => {
            const values = isNew
              ? [data.appendId, selectedOption.value, data.typeId]
              : isReturns
                ? [data.appendId, selectedOption.value, data.typeId]
                : [];
            performMappingUpdate(props, values);
          }}
        >
          {currentSelection}
          <Icon type="chevron-down" className="ml-[4px]" />
        </TriggerableMenu>
      ) : (
        currentSelection
      )}
    </div>
  );
};
